import React from "react";
import { SocialMedia, NavigationalDots } from "../components";

const AppWrap = (Component, idName, classNames) =>
  function HOC() {
    return (
      <div id={idName} className={`app__container ${classNames}`}>
        <SocialMedia />
        <div className="app__wrapper app__flex">
          <Component />
          <div className="copyright">
            <p className="p-text"></p>
            <p className="p-text"></p>
          </div>
        </div>
        <NavigationalDots active={idName} />
      </div>
    );
  };

export default AppWrap;
